import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CampaignManagementState } from '../models/campaign-management.model';
import * as selectors from '../selectors/search.selectors';

@Injectable({ providedIn: 'root' })
export class CampaignManagementFacadeService extends FacadeService {
  constructor(public override store: Store<CampaignManagementState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  campaignName$ = this.storeSelect(selectors.getCampaignName);
  schemaOptions$ = this.storeSelect(selectors.getSchemas);
  schemaId$ = this.storeSelect(selectors.getSchemaId);
  schema$ = this.storeSelect(selectors.getSchema);
  countryOptions$ = this.storeSelect(selectors.getCountries);
  countryName$ = this.storeSelect(selectors.getCountryName);
  countryId$ = this.storeSelect(selectors.getCountryId);
  channelOptions$ = this.storeSelect(selectors.getChannelOptions);
  channel$ = this.storeSelect(selectors.getChannel);
  startDateFormat$ = this.storeSelect(selectors.getStartDateFormat);
  startDateValidation$ = this.storeSelect(selectors.getStartDateValidation);
  endDateFormat$ = this.storeSelect(selectors.getEndDateFormat);
  endDateValidation$ = this.storeSelect(selectors.getEndDateValidation);
  campaignEndDateLTStartDate$ = this.storeSelect(selectors.getCampaignEndDateLTStartDate);

  // OBSERVABLES' VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get campaignName() {
    return this.storeSnapshot(this.campaignName$);
  }

  get schemaOptions() {
    return this.storeSnapshot(this.schemaOptions$);
  }

  get schema() {
    return this.storeSnapshot(this.schema$);
  }

  get schemaId() {
    return this.storeSnapshot(this.schemaId$);
  }

  get channel() {
    return this.storeSnapshot(this.channel$);
  }

  get startDateFormat() {
    return this.storeSnapshot(this.startDateFormat$);
  }

  get endDateFormat() {
    return this.storeSnapshot(this.endDateFormat$);
  }

  get countryId() {
    return this.storeSnapshot(this.countryId$);
  }

  get countryOptions() {
    return this.storeSnapshot(this.countryOptions$);
  }
}
